import { Injectable } from '@angular/core';
import { Auth, UserInfo, updateProfile, getAuth } from '@angular/fire/auth';
import {
  Firestore,
  query,
  orderBy,
  limit,
  collectionData,
  startAfter,
  getDocs,
  where,
  doc,
  setDoc,
  addDoc,
  startAt,
  endAt,
  getDoc,
  updateDoc,
  runTransaction,
  arrayUnion,
  arrayRemove,
  WhereFilterOp,
  deleteDoc,
} from '@angular/fire/firestore';
import {
  collection,
  Timestamp,
  disableNetwork,
  enableNetwork,
  OrderByDirection,
  DocumentData,
} from '@firebase/firestore';
import { concatMap, Observable, of, from, map, combineLatest } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class FirestoreService {
  lastVisible: any;
  constructor(private auth: Auth, private firestore: Firestore,) { }
  async getDataListWithLimitFromGeneral(
    collectionname: string,
    limitnum: number,
    orderby: string
  ) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      orderBy(orderby, 'desc'),
      limit(limitnum)
    );
    const documentSnapshots = await getDocs(datalistref);
    this.lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];
    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;

      dataarry.push(data);
    });

    return dataarry;
  }


  async getDataListWithLimitFrom(collectionname: any, limitnum: any,bywhome:any) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      where('bywhom', '==', bywhome),
      orderBy('cdate', 'desc'),
      limit(limitnum)
    );
    const documentSnapshots = await getDocs(datalistref);
    this.lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];
    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;
      dataarry.push(data);
    });

    return dataarry;
  }

 // Method to fetch data from Firestore
 async getTrainingData(): Promise<DocumentData[]> {
  try {
    // Reference to the Firestore collection
    const datalistRef = query(collection(this.firestore, 'trainingData'));

    // Get document snapshots
    const documentSnapshots = await getDocs(datalistRef);

    // Map document data to an array
    const data = documentSnapshots.docs.map(doc => doc.data());

    return data;
  } catch (error) {
    console.error('Error fetching training data:', error);
    throw error;
  }
}

  // getaiTrainingData(): Observable<any[]> {
  //   return this.angularfirestore.collection('trainingData').valueChanges();
  // }

  async loadMoreDataFrom(collectionname: any, limitnum: any) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      where('publishStatus', '==', true),
      orderBy('publishdate', 'desc'),
      startAfter(this.lastVisible),
      limit(limitnum)
    );

    const documentSnapshots = await getDocs(datalistref);
    this.lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;
      dataarry.push(data);
    });

    return dataarry;

    // const datalistref = query(collection(this.firestore,collectionname),orderBy('publishdate','desc'),startAfter(lastviewed),limit(limitnum));
    // const documentSnapshots = await getDocs(datalistref);
  }
  async loadMoreDataFromGeneral(
    collectionname: string,
    limitnum: number,
    orderby: string
  ) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      orderBy(orderby, 'desc'),
      startAfter(this.lastVisible),
      limit(limitnum)
    );

    const documentSnapshots = await getDocs(datalistref);
    this.lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;
      dataarry.push(data);
    });

    return dataarry;
  }







  async getAuthUserProfile() {
    return new Promise(async (resolve, reject) => {
      await this.getUserDetails().then(async (res: any) => {
        if (res) {
          await this.getUserProfile(res.uid).then((resp) => {
            resolve(resp);
          });
        } else {
          resolve('No Auth User');
        }
      });
    });
  }
  async updateAuthDetails(propname: string, propval: any) {
    let currentUser: any = getAuth().currentUser;
    let thisauth: any = this.auth.currentUser;
    try {
      await updateProfile(currentUser, {
        [propname]: propval,
      });
    } catch (e: any) { }
  }

  async updateAuthDetailsImg(url: string) {
    let currentUser: any = getAuth().currentUser;
    try {
      await updateProfile(currentUser, {
        photoURL: url,
      });
    } catch (e: any) { }
  }

  async getDocumentByIDFrom(collectionname: any, key: any) {
    const datalistref = doc(this.firestore, collectionname, key);
    const docsnap = await getDoc(datalistref);
    if (docsnap.exists()) {
      let obj: any = docsnap.data();
      obj.key = docsnap.id;
      obj.id = docsnap.id;
      return obj;
    } else {
      // doc.data() will be undefined in this case
      //
    }
  }
  async getUserProfile(currentUID: string) {
    return new Promise(async (resolve, reject) => {
      await this.getDocumentByIDFrom('users-list', currentUID).then((res) => {
        if (res) {
          resolve(res);
        } else {
          resolve('No user Details');
        }
      });
    });
  }

  async getCollectionList(
    collectionname: any,
    orderby: any,
    orderdirection: any
  ) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      orderBy(orderby, orderdirection)
    );
    const documentSnapshots = await getDocs(datalistref);
    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      // dataarry.push(element.data())
      const id = element.id;
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;
      dataarry.push(data);
    });

    return dataarry;
  }
  async getUserDetails() {
    return new Promise((resolve) => {
      resolve(this.auth.currentUser);
    });
  }
  async getDocFromWhereEqual(collectionname: any, propname: any, propval: any) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      where(propname, '==', propval)
    );
    const documentSnapshots = await getDocs(datalistref);
    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      let obj: any = element.data();
      obj.key = element.id;
      obj.id = element.id;
      dataarry.push(obj);
    });

    return dataarry;
  }

  async getDocFromWhereEqualObj(collectionname: any, propname: any, propval: any) {
  const datalistref = query(
    collection(this.firestore, collectionname),
    where(propname, '==', propval)
  );
  const documentSnapshots = await getDocs(datalistref);

  if (documentSnapshots.empty) return null;

  const firstDoc = documentSnapshots.docs[0];
  let obj: any = firstDoc.data();
  obj.key = firstDoc.id;
  obj.id = firstDoc.id;

  return obj;
}


  async updateDocumentWithIDOF(collectionname: any, key: any, dataobj: any) {
    const sfDocRef = doc(this.firestore, collectionname, key);
    try {
      await runTransaction(this.firestore, async (transaction) => {
        const sfDoc = await transaction.get(sfDocRef);
        if (!sfDoc.exists()) {
          throw 'Document does not exist!';
        }
        console.log(dataobj);

        transaction.update(sfDocRef, Object.assign({}, dataobj), {
          merge: true,
        });
      });

      return true;
    } catch (e) {
      console.log('errrr',e);
      
      return false;
    }
  }


  async addDocumentTo(collectionname: any, formdataobj: any) {
    console.log(formdataobj);
    
    const datalistref = query(
      collection(this.firestore, collectionname),
      where('refno', '==', formdataobj.refno)
    );
    const documentSnapshots = await getDocs(datalistref);

    if (documentSnapshots.size > 0) {
      return;
    } else {
      const docRef = await addDoc(
        collection(this.firestore, collectionname),
        Object.assign({}, formdataobj)
      );
      return new Promise((resolve) => {
        resolve(docRef.id);
      })
    }
  }

  async addDocumentTocollection(collectionname: any, formdataobj: any) {
    const datalistref = query(
      collection(this.firestore, collectionname),
      where('refno', '==', formdataobj.refno)
    );
    const documentSnapshots = await getDocs(datalistref);

    if (documentSnapshots.size > 0) {
      return;
    } else {
      const docRef = await addDoc(
        collection(this.firestore, collectionname),
        Object.assign({}, formdataobj)
      );
      return new Promise((resolve) => {
        resolve(docRef.id);
      });
    }
  }

  async setDocumentToWithCustomKey(collectionname: any,formdataobj: any,key: string) {  
    return new Promise(async (resolve) => {
      await setDoc(
        doc(this.firestore, collectionname, key),
        Object.assign({}, formdataobj),
        { merge: true }
      )  .then((res)=>{
        resolve(true);
      }).catch((err)=>{
        resolve(err);
      })

    });
  }

  async getCollectionDocumentFrom(collectionname: any) {
    const datalistref = query(collection(this.firestore, collectionname));
    const documentSnapshots = await getDocs(datalistref);
    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;
      dataarry.push(data);
      // dataarry.push(element.data())
    });

    return dataarry;
  }
  async getCollectionDocumentByRoleFrom(collectionname: any, role: any) {
    const datalistref = query(collection(this.firestore, collectionname));
    const documentSnapshots = await getDocs(datalistref);
    let dataarry: any = [];
    documentSnapshots.forEach((element) => {
      const data: any = element.data();
      data.key = element.id;
      data.id = element.id;
      dataarry.push(data);
      // dataarry.push(element.data())
    });

    return dataarry;
  }
  async updateArrayUnionInDocumentWithIDOF(
    collectionname: any,
    key: any,
    propname: string,
    propval: any
  ) {
    const sfDocRef = doc(this.firestore, collectionname, key);
    try {
      await updateDoc(sfDocRef, {
        [propname]: arrayUnion(propval),
      });

      return true;
    } catch (e) {
      return false;
    }
  }
  searchMasterList(searchword: string,collectionname:any,bywhomeid:any) {
    //code for a single word search

    // const lowercasedSearchWords = searchword.toLowerCase();
    // console.log(searchword, lowercasedSearchWords);
    // const masterListRef = collection(this.firestore, 'searchwordsarray');
    // const masterListQuery = query(masterListRef, where('materials-list', 'array-contains', lowercasedSearchWords));
    // return from(getDocs(masterListQuery)).pipe(
    //   map(snapshot => snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    // );
    // return masterListQuery;
    //code for multiple words search
    const wordsArray = searchword.toLowerCase().split(' ');
    const masterListRef = collection(this.firestore, collectionname);
    console.log(masterListRef);
    console.log(wordsArray)
    
    const queries$ = wordsArray.map(word =>

      from(getDocs(query(masterListRef, where('searchwordsarray', 'array-contains', word)))));
    return combineLatest(queries$).pipe(
      map(resultsArray => {
        const allDocs: any[] = [];
        resultsArray.forEach(result => {
          result.docs.forEach(doc => {
            console.log(result);
            console.log(bywhomeid);
            console.log(doc);
            
            
            // Avoid duplicating documents by checking if the ID is already in the array
            if (
              !allDocs.some(existingDoc => existingDoc.id === doc.id) &&
              (doc.data()['bywhom'] === bywhomeid || doc.data()['bywhome'] === bywhomeid)
            ) {
              allDocs.push({ id: doc.id, ...doc.data() });
            }
          });
    
          });
        return allDocs;
      })
    );
  }

  // to add image 
  updateDocument(collectionName: string, docId: string, data: any) {
    const documentRef = doc(this.firestore, `${collectionName}/${docId}`);
    return updateDoc(documentRef, data);
  }


}

